import { httpClient } from '../httpClient';
export class PayinfoRepository {
    // SLN暗号化
    async getSlnEncrypt() {
        const { data } = await httpClient.get(`payinfo/sln-encrypt`);
        return data;
    }
    // カード変更後処理
    async cardChangeAfter(params) {
        const { data } = await httpClient.post(`payinfo/card-change-after`, JSON.stringify(({ encryptValue: params.encryptValue } = params)));
        return data;
    }
    // カード無効取得
    async getPaymentInvalid() {
        const { data } = await httpClient.get(`payinfo/payment-invalid`);
        return data;
    }
}
